import { Navigate, Route, Routes } from "react-router-dom";
import { AccessGate } from "./components/AccessGate";
import { AppShell } from "./components/AppShell";
import { DashboardPage } from "./pages/DashboardPage";
import { DialerPage } from "./pages/DialerPage";
import { ContactsPage } from "./pages/ContactsPage";
import { CampaignsPage } from "./pages/CampaignsPage";
import { CampaignDetailPage } from "./pages/CampaignDetailPage";
import { CallsPage } from "./pages/CallsPage";
import { SettingsPage } from "./pages/SettingsPage";
import { AdminPage } from "./pages/AdminPage";
import { AdminTelephonyPage } from "./pages/AdminTelephonyPage";
import { AgentTelephonyPage } from "./pages/AgentTelephonyPage";
import { AgentHeadsetPage } from "./pages/AgentHeadsetPage";
import { MegaReserveSupportPage } from "./pages/MegaReserveSupportPage";

export default function App() {
  return (
    <AccessGate>
      {(ctx) => (
        <AppShell user={ctx.user} admin={ctx.admin} megaReserve={ctx.admin || Boolean(ctx.staff?.serviceContexts?.includes("MEGAFED"))}>
          <Routes>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/dialer" element={<DialerPage csrf={ctx.csrf} />} />
            <Route path="/headset" element={<AgentHeadsetPage csrf={ctx.csrf} />} />
            <Route path="/contacts" element={<ContactsPage csrf={ctx.csrf} />} />
            <Route path="/campaigns" element={<CampaignsPage csrf={ctx.csrf} />} />
            <Route path="/campaigns/:id" element={<CampaignDetailPage csrf={ctx.csrf} />} />
            <Route path="/calls" element={<CallsPage csrf={ctx.csrf} />} />
            <Route path="/settings" element={<SettingsPage csrf={ctx.csrf} />} />
            <Route path="/telephony" element={<AgentTelephonyPage csrf={ctx.csrf} />} />
            {ctx.admin || ctx.staff?.serviceContexts?.includes("MEGAFED") ? <Route path="/mega-reserve" element={<MegaReserveSupportPage csrf={ctx.csrf} />} /> : null}
            {ctx.admin ? <Route path="/admin" element={<AdminPage csrf={ctx.csrf} />} /> : null}
            {ctx.admin ? <Route path="/admin/telephony" element={<AdminTelephonyPage csrf={ctx.csrf} />} /> : null}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AppShell>
      )}
    </AccessGate>
  );
}
